// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultPriceTierFeatureItemProps,
  PlasmicPriceTierFeatureItem,
} from "@/wab/client/plasmic/plasmic_kit_pricing/PlasmicPriceTierFeatureItem";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import * as React from "react";

export type PriceTierFeatureItemProps = DefaultPriceTierFeatureItemProps;

function PriceTierFeatureItem_(
  props: PriceTierFeatureItemProps,
  ref: HTMLElementRefOf<"div">
) {
  return <PlasmicPriceTierFeatureItem root={{ ref }} {...props} />;
}

const PriceTierFeatureItem = React.forwardRef(PriceTierFeatureItem_);
export default PriceTierFeatureItem;
